/**
 * @file: 接口api
 * @author: wangzhenhai02@baidu.com
 * @Date: 2021-07-19 15:47:55
 * @LastEditors: chenyingliao <chenyingliao@baidu.com>
 * @LastEditTime: 2024-01-23 16:34:46
 * @FilePath: /console-znzs/src/api/robot.js
 */
import request from '@/znzs/src/utils/request';

/**
 * @deprecated
 * 评价机器人
 */
export function evaluateRobot(data) {
    return request({
        url: '/evaluate/robot',
        method: 'POST',
        data,
    });
}

/**
 * @deprecated
 * 机器人评价话术
 * @returns
 */
export function robotEvaluateOptions() {
    return request({
        url: '/robot-config/robot-evaluate-words',
        method: 'GET',
    });
}

// 获取服务公告列表
export function getServiceNotice(params) {
    return request({
        url: '/announcement',
        method: 'GET',
        params,
    });
}

// 自助工具或者快捷入口
export function getSelfHelpToolOrEntryQuick(params) {
    return request({
        url: '/robot-config',
        method: 'GET',
        params,
    });
}

// 猜你想了解中的快捷自助工具入口
export function getSelfTools(params) {
    return request({
        url: '/recommend/self-help-tools',
        method: 'GET',
        params,
    });
}

// 知识评价
export function evaluateSingleKnowledge(data) {
    return request({
        url: '/evaluate/dialog',
        method: 'POST',
        data,
    });
}

// 知识评价话术
export function knowledgeEvaluateOptions(params) {
    return request({
        url: '/robot-config/knowledge-evaluate-words',
        method: 'GET',
        params,
    });
}

// 机器人配置
export function robotConfigs(params) {
    return request({
        url: '/robot-config/bot-base-info',
        method: 'GET',
        params,
    });
}

// 输入联想推荐
export function inputRecommand(params) {
    return request({
        url: '/recommend/association',
        method: 'GET',
        params,
    });
}

// 用户提交问题
export function userSubmitQuestion(data) {
    return request({
        url: '/question',
        method: 'POST',
        data,
    });
}

/**
 * @deprecated
 * 快捷导航按钮推荐
 * @param {*} knowledgeId
 * @param {*} type
 * @returns
 */
export function getNavigations(knowledgeId, type) {
    return request({
        url: `/recommend/navigations?knowledgeId=${knowledgeId}&type=${type ? type : ''}`,
        method: 'GET',
    });
}

// 历史对话记录
export function getHistoryChat(params) {
    return request({
        url: '/dialogs',
        method: 'GET',
        params,
    });
}

// 获取欢迎语
export function getWelcomeWords(params) {
    return request({
        url: '/welcome',
        method: 'GET',
        params,
    });
}

// 猜你想问
export function guessWantToAsk(params) {
    return request({
        url: '/recommend/question',
        method: 'GET',
        params,
    });
}

// 根据工单类型获取自动提问话术
export function getAutoAskFromOrder(params) {
    return request({
        url: '/auto-ask',
        method: 'GET',
        params,
    });
}

/**
 * 上传图片
 * @param {*} data
 * @returns
 */
export function uploadImage(data) {
    return request({
        url: '/file/upload',
        method: 'POST',
        data,
    });
}

/**
 * @deprecated
 * 查询转人工话术
 */
export function queryManualWords() {
    return request({
        url: '/robot-config/turn-manual-words',
        method: 'GET',
    });
}

// 获取会话对应的工单三级类型id
export function getTicketType() {
    return request({
        url: '/session',
        method: 'GET',
    });
}

/**
 * 回传自助工具的检查结果
 * @param {string} data 自助工具的检查结果
 * @returns
 */
export const postCheckResult = data => request.post('/self-help-tool-operation-record', data);

/**
 * @description: 查询用户是否在功能白名单中
 * 主要包含3个场景
 * 1. IM
 * 2. 机器人回复
 * 3. 评价知识
 * 4. 上传图片给大模型解析：BETA_VERSION
 */
export function isIninWhitelist(params) {
    return request({
        url: '/common/in-feature-whitelist',
        method: 'GET',
        params,
    });
}

/**
 * @description: 更新机器人会话中的产品/问题类型
 * @return {*}
 */
export function updateProductAndQuestionId(data) {
    return request({
        url: '/session/question-id',
        method: 'PUT',
        data,
    });
}

/**
 * 提交工单卡片中，根据关键词在知识标准问和相似问中模糊搜索
 * https://yapi.baidu-int.com/project/18492/interface/api/2045802
 * @param {*} keyword
 * @returns
 */
export const getRecommendSearch = keyword => request.get('/recommend/search-by-question', {params: {keyword}});

/**
 * 根据用户输入的问题，匹配对应的产品类型
 * https://yapi.baidu-int.com/project/18492/interface/api/2504342
 * @param {*} input
 * @returns
 */
export const getProductByText = input => request.get('/session/predict-type-by-input', {params: {input}});
